<template>
  <div class="pa-8">
    <v-tabs v-model="tab">
      <v-tab id="editrack-en-tab">English</v-tab>
      <v-tab id="editrack-pt-tab">Português</v-tab>
      <v-tab id="editrack-es-tab">Español</v-tab>
    </v-tabs>
    <v-divider></v-divider>

    <v-tabs-items v-model="tab" v-if="track">
      <v-tab-item class="pa-3">
        <EditTrackContent
          ref="trackContent1"
          lang="en"
          :content="track.content != undefined ? track.content.en : {}"
        />
      </v-tab-item>
      <v-tab-item class="pa-3">
        <EditTrackContent
          ref="trackContent2"
          lang="pt"
          :content="track.content != undefined ? track.content.pt : {}"
        />
      </v-tab-item>
      <v-tab-item class="pa-3">
        <EditTrackContent
          ref="trackContent3"
          lang="es"
          :content="track.content != undefined ? track.content.es : {}"
        />
      </v-tab-item>
    </v-tabs-items>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="editrack-save-button"
          v-on="on"
          @click="edit ? updateTrack() : createTrack()"
          color="#FBBD21"
          dark
          fab
          fixed
          bottom
          right
        >
          <v-icon>{{ icon.mdiContentSave }}</v-icon>
        </v-btn>
      </template>

      <span>Save</span>
    </v-tooltip>

    <!-- Administration Track Form Step -->
    <v-card class="ma-5">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Administration Track</v-toolbar-title>
      </v-toolbar>
      <v-row class="pa-10">
        <v-col cols="4">
          <div style="font-weight: 300, font-size: 110%">
            Choose a color to represent this track
          </div>
          <v-color-picker
            id="editrack-admin-color-picker"
            class="mx-4"
            hide-canvas
            v-model="color"
          ></v-color-picker>
        </v-col>
        <v-col cols="8">
          <v-select
            id="editrack-admin-user-select"
            v-model="admin"
            dense
            outlined
            label="Track Admin"
            @change="addAdmin"
            :items="users"
            item-text="email"
            return-object
          ></v-select>

          <v-list v-if="track && track.admins.length">
            <v-list-item
              v-for="(admin, i) in track.admins"
              :key="i"
              link
              :ripple="false"
              style="cursor: default"
            >
              <v-list-item-avatar>
                <v-img
                  contain
                  height="100"
                  v-if="admin.image"
                  :src="admin.image"
                  :alt="admin.title + ' picture'"
                />
                <v-avatar v-else color="primary">
                  <v-icon dark> {{ icon.mdiAccount }} </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ admin.email }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon @click="removeAdmin(i)" :id="'editrack-admin-user-remove-button-' + admin.id">
                  <v-icon color="grey lighten-1">{{ icon.mdiClose }}</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <div v-else class="red--text">
            No admins added yet. At least 1 Admin is Required!
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import EditTrackContent from "@/components/molecules/tracks/EditTrackContentForm.vue";
import { trackToClass } from "@/helpers/tracks.js";
import { mdiClose, mdiAccount, mdiContentSave } from "@mdi/js";

export default {
  components: {
    EditTrackContent,
  },
  data: () => ({
    icon: {
      mdiClose,
      mdiAccount,
      mdiContentSave,
    },
    tab: 0,
    admin: {},
    edit: false,
    track: null,
    color: "",
    removedAdmins: [],
  }),
  methods: {
    async updateTrack() {
      let trackId = this.$route.params.trackId;
      if (
        !this.$refs.trackContent1.validate() ||
        this.track.admins.length < 1
      ) {
        alert("You need to fill all required fields");
      } else {
        let formattedTrack = trackToClass(this.track);
        let updated = await this.$store.dispatch("updateTracks", {
          id: trackId,
          data: formattedTrack,
          user: {
            uid: this.currentUser.id,
            roles: this.currentUser.roles,
          },
        });
        if (updated) {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Success on update track!",
            color: "success",
          });
        } else {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error on update track",
            color: "error",
          });
        }
        //add track id to admin
        this.track.admins.forEach((admin) => {
          let user = this.users.find((user) => user.id == admin.id);
          if (!user?.tracks?.includes(trackId)) {
            this.$store.dispatch("addTrackId", {
              id: user.id,
              element: trackId,
            });
          }
        });

        //remove track id from removed admins
        this.removedAdmins.forEach((admin) => {
          let user = this.users.find((user) => user.id == admin.id);

          if (
            user?.tracks?.includes(trackId) &&
            !this.track.admins.includes(admin)
          ) {
            this.$store.dispatch("removeTrackId", {
              id: user.id,
              element: trackId,
            });
          }
        });
        this.updateRole("ta");
        this.$router.push("/dashboard/tracks");
      }
    },
    async createTrack() {
      let trackId = this.$route.params.trackId;
      if (
        !this.$refs.trackContent1.validate() ||
        this.track.admins.length < 1
      ) {
        alert("You need to fill all required fields");
      } else {
        await this.$store
          .dispatch("createTracks", {
            data: this.track,
            user: {
              uid: this.currentUser.id,
              roles: this.currentUser.roles,
            },
          })
          .then((id) => {
            this.$store.dispatch("setSnackbar", {
              show: true,
              text: "Success on create track!",
              color: "success",
            });
            this.track.admins.forEach((admin) => {
              let user = this.users.find((user) => user.id == admin.id);
              if (!user?.tracks?.includes(trackId)) {
                this.$store.dispatch("addTrackId", {
                  id: user.id,
                  element: id,
                });
              }
            });
          })
          .catch((err) => {
            console.log("Error Create Track", err);
            this.$store.dispatch("setSnackbar", {
              show: true,
              text: "Oops... Error on create track",
              color: "error",
            });
          });
        this.updateRole("ta");
        this.$router.push("/dashboard/tracks");
      }
    },
    updateRole(role) {
      this.track.admins.forEach((admin) => {
        let user = this.users.find((user) => user.id == admin.id);
        if (!user.roles.includes(role)) {
          user.roles.push(role);
          this.$store.dispatch("updateUserRole", user);
        }
      });
    },
    addAdmin() {
      let hasAdmin = this.track.admins.find(
        (admin) => admin.id == this.admin.id
      );

      if (!hasAdmin)
        this.track.admins.push(
          Object.assign({}, { id: this.admin.id, email: this.admin.email })
        ); //ony add if not already added
    },
    removeAdmin(index) {
      this.removedAdmins.push(Object.assign({}, this.track.admins[index]));
      this.track.admins.splice(index, 1);
    },
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    currentTrack() {
      return this.$store.state.track.currentTrack;
    },
    tracks() {
      return this.$store.getters.getTracks || [];
    },
    users() {
      return this.$store.getters.getUsers || [];
    },
    currentUser() {
      return this.$store.getters.getUser;
    },
  },
  async created() {
    var trackId = this.$route.params.trackId;
    if (trackId) {
      this.edit = true;
      await this.$store.dispatch("getTrackById", { trackId: trackId });
      this.track = Object.assign({}, this.$store.state.track.currentTrack);
      this.color = this.$store.state.track.currentTrack.color;
    } else {
      this.edit = false;
      this.track = trackToClass({});
    }
  },
};
</script>
